export default "__VITE_ASSET__CvS5tr3O__"